import { createI18n } from 'vue-i18n';
import { set } from 'lodash-es';
import { defineStore } from 'pinia';
import { reactive, ref } from 'vue';
import { Locales, normalizeLocale, localeOptions } from '@/locales/resources';
import { removeURLParameter } from '@/utils/util';

const modules = import.meta.glob('/locales/**/*', { eager: true });

function bodyLang(locals: string) {
  const html = document.querySelector('html') as HTMLElement;
  const body = document.querySelector('body') as HTMLElement;

  if (body) {
    body.setAttribute('data-lang', locals);
  }

  if (locals === 'ar') {
    html.setAttribute('dir', 'rtl');
  } else {
    html.removeAttribute('dir');
  }
}

const i18n = createI18n({
  locale: normalizeLocale(),
  legacy: false,
  fallbackLocale: 'en-US',
  globalInjection: true,
  messages: {
    ...genMessage(modules),
  },
});

export { i18n };

export function genMessage(langs: any, prefix = 'locales') {
  const obj = {};

  Object.keys(langs).forEach((key: any) => {
    const langFileModule = langs?.[key].default;

    let fileName = key.replace(`/${prefix}/`, '').replace(/^\.\//, '');
    const lastIndex = fileName.lastIndexOf('.');
    fileName = fileName.substring(0, lastIndex);
    const keyList = fileName.split('/');
    const moduleName = keyList?.shift();
    const objKey = keyList.join('.');

    if (moduleName) {
      if (objKey) {
        // @ts-ignore
        set(obj, moduleName, obj[moduleName] || {});
        // @ts-ignore
        set(obj[moduleName], objKey, langFileModule);
      } else {
        set(obj, moduleName, langFileModule || {});
      }
    }
  });
  return obj;
}

export const useLocale = defineStore('locale', () => {
  const locale = ref(
    normalizeLocale(localStorage.getItem('locale') || undefined)
  );
  bodyLang(locale.value);
  const localeArray = reactive(localeOptions);

  return { locale, localeArray };
});

export const useChangeLocale = async (lang: Locales) => {
  const globalI18n = i18n.global;
  console.log(globalI18n);
  const { localeArray } = useLocale();

  // const defaultLocale = await import(`/locales/ja-JP/assets.json`);
  // console.log(defaultLocale);
  // const message = defaultLocale.default?.message ?? {};
  // if (!message) return;

  // globalI18n.setLocaleMessage(lang, message);
  globalI18n.locale.value = lang;

  if (localeArray?.find((item: LocaleOption) => item.value === lang)) {
    localStorage.setItem('locale', lang);
    bodyLang(lang);
    removeURLParameter('lan');
    location.reload();
  }
};
